export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";